(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Auth', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Auth, Principal, LoginService, $state) {
        var vm = this;
        
        vm.authenticationError = false;
        vm.loginSicei = loginSicei;
        vm.passwordSicei = null;
        vm.usernameSicei = null;
        vm.loginExterno = loginExterno;
        vm.passwordExterno = null;
        vm.usernameExterno = null;
        vm.rememberMe = true;
        
        vm.account = null;
        vm.isAuthenticated = null;
        vm.requestResetPassword = requestResetPassword;
        vm.register = register;
        
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {            	
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        
        function loginSicei (event) {
            event.preventDefault();
            Auth.login({
                username: vm.usernameSicei + "@sicei",
                password: vm.passwordSicei,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                getAccount();
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
        
        function loginExterno (event) {
            event.preventDefault();
            Auth.login({
                username: vm.usernameExterno + "@externo",
                password: vm.passwordExterno,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                getAccount();
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
        
        function register () {
            $state.go('register');
        }
        
        function requestResetPassword () {
            $state.go('requestReset');
        }
    }
})();
